import { useCallback, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { actions } from 'store'

const useOnPlayPause = () => {
    const dispatch = useDispatch()
    const { wavesurfer, isPlaying } = useSelector(state => state.wavesurfer)

    const isPlayingRef = useRef(isPlaying);
    const wavesurferRef = useRef(wavesurfer);

    useEffect(() => {
        isPlayingRef.current = isPlaying;
    }, [isPlaying])

    useEffect(() => {
        wavesurferRef.current = wavesurfer;
    }, [wavesurfer])

    const setIsPlaying = (value) => {
        dispatch(actions.setIsPlaying(value))
    }

    const playPause = () => {
        if (wavesurferRef.current)
            wavesurferRef.current.playPause()
    }

    const onPlayPause = useCallback(() => {
        setIsPlaying(!isPlayingRef.current)
        playPause()
    }, [])

    return onPlayPause
}

export default useOnPlayPause 